module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.contents,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "コンテンツ名",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "価格",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "公開期間",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(scope.row.publishBegin)) + " - " + _vm._s(_vm._f("formatDate")(scope.row.publishEnd)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "視聴期間",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(scope.row.showBegin)) + " - " + _vm._s(_vm._f("formatDate")(scope.row.showEnd)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "シリーズ",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [('series' in scope.row) ? _c('span', [('parent' in scope.row.series) ? _c('span', [_vm._v(_vm._s(scope.row.series.parent.name) + " > ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(scope.row.series.name) + "\n                ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "サムネイル",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.images), function(image) {
          return _c('img', {
            staticClass: "trim",
            attrs: {
              "width": "100",
              "height": "100",
              "src": ((_vm.config.aws.s3.getbucket) + "/images/" + (image.path))
            }
          })
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "カテゴリ",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.categories), function(category) {
          return _c('span', [_vm._v("\n                    " + _vm._s(category.name) + "\n                ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contentsId",
      "label": "コンテンツID",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ビュー",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.addView(scope.row.id)
            }
          }
        }, [_vm._v("視聴したことにする")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-350d110c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User.vue
// module id = 1135
// module chunks = 1